// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"up-z","badgeLink":"vp-z","category":"wp-z"};